module.exports = __webpack_public_path__ + "static/media/flecheLiJaune.b797e1df.svg";